// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f999647","732":"be220b68","977":"1c7636ce"}[chunkId] + ".chunk.js";
};